export default "__VITE_ASSET__BK6NfBMC__"